<span class='export' >
    <mat-spinner matSuffix [diameter]="18" class='spinner export-spinner' *ngIf='showSpinner | async'></mat-spinner>
    <button mat-button color="accent" class='exportButton' [disabled]="showSpinner.value" (click)="exportCSV() ">
        <div>
            <img src="/assets/images/download.svg" class="downloadIcon" *ngIf='!showSpinner.value'>
            <span>Export (CSV)</span>
        </div>
    </button>
</span>
